import React from 'react';
import './Background.css';


const Background = () => {
    return (
        <div className='Background'>
            <div className='background-image'></div>
            <div className='background-overlay'></div>
            

        </div>
    );
};

export default Background;